import { Box, Button, IconButton, InputBase, Pagination } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { TableMui } from "../../components/mui";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export default () => {
  const navigate = useNavigate();
  const handleFieldButtonClick = () => {
    navigate("/advertiserViewCampaign");
  };
  useEffect(() => {
    document.title = "RollingAdz: Compaign" || "Default Title";
  }, []);
  const data = [
    {
      campaign: "campaign setup",
      vehicle_Job: "A video of a cat playing with a toy",
      photographer_job: "2022-04-20",
      advertiser_job: "13:30:00",
      installer_job: "Usman",
      start_date: "27-01-2023",
      end_date: "27-05-2023",
      advertiser: "Dell",
      detail: "A dummy text",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      campaign: "campaign execution",
      vehicle_Job: "A video of a cat playing with a toy",
      photographer_job: "2022-04-20",
      advertiser_job: "13:30:00",
      installer_job: "Usman",
      start_date: "27-01-2023",
      end_date: "27-05-2023",
      advertiser: "Dell",
      detail: "A dummy text",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      campaign: "live campaign",
      vehicle_Job: "A video of a cat playing with a toy",
      photographer_job: "2022-04-20",
      advertiser_job: "13:30:00",
      installer_job: "Usman",
      start_date: "27-07-2023",
      end_date: "27-08-2023",
      advertiser: "Dell",
      detail: "A dummy text",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      campaign: "removing wrap",
      vehicle_Job: "A video of a cat playing with a toy",
      photographer_job: "2022-04-20",
      advertiser_job: "13:30:00",
      installer_job: "Usman",
      start_date: "27-03-2023",
      end_date: "27-11-2023",
      advertiser: "Dell",
      detail: "A dummy text",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      campaign: "ramp down(retargeting)",
      vehicle_Job: "A video of a cat playing with a toy",
      photographer_job: "2022-04-20",
      advertiser_job: "13:30:00",
      installer_job: "Usman",
      start_date: "27-02-2023",
      end_date: "27-10-2023",
      advertiser: "Dell",
      detail: "A dummy text",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
  ];
  return (
    <>
      <div
        className=" d-flex justify-content-between align-items-center px-4 col-md-6"
        style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
      >
        <InputBase
          className=""
          sx={{
            ml: 1,
            flex: 1,
            px: 1,
          }}
          placeholder="Search..."
          type="search"
        />
        <Box
          sx={{
            width: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            type="button"
            sx={{
              p: "5px",
              backgroundColor: "#3E4755",
              color: "white",
              "&:hover": {
                backgroundColor: "#3E4755",
                color: "white",
              },
            }}
            aria-label="search"
          >
            <Search style={{ fontSize: 25 }} />
          </IconButton>
        </Box>
      </div>
      <div className="d-flex justify-content-center">
        <h1 style={{ color: "black" }}>Campaigns</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            campaign: (
              <>
                Name <FilterAltOutlinedIcon />
              </>
            ),
            // vehicle_Job: (
            //   <>
            //     Vehicle Job <FilterAltOutlinedIcon />
            //   </>
            // ),
            // photographer_job: (
            //   <>
            //     Photographer Job <FilterAltOutlinedIcon />
            //   </>
            // ),
            // advertiser_job: (
            //   <>
            //     Advertiser Job <FilterAltOutlinedIcon />
            //   </>
            // ),
            // installer_job: (
            //   <>
            //     Installer Job <FilterAltOutlinedIcon />
            //   </>
            // ),

            start_date: (
              <>
                Start Date <FilterAltOutlinedIcon />
              </>
            ),
            end_date: (
              <>
                End Date <FilterAltOutlinedIcon />
              </>
            ),
            campaign: (
              <>
                Campaign stage <FilterAltOutlinedIcon />
              </>
            ),
            advertiser: (
              <>
                Advertiser <FilterAltOutlinedIcon />
              </>
            ),
            detail: (
              <>
                Details <FilterAltOutlinedIcon />
              </>
            ),
            view: "Button",
          }}
          td={data}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </>
    // <div>
    //   <div className="site-content h-100">
    //     <div className="p-4">
    //       <div className="site-content-body">
    //         <div className="container gx-0">
    //           <div className="row">
    //             <div className="col">
    //               <div>
    //                 <div className="d-md-flex flex-wrap justify-content-between  pt-2 px-4">
    //                   <div className="d-md-flex gap-2 my-2">
    //                     <div className="d-flex pe-1 search_All_border rounded-pill mb-sm-0 mb-2">
    //                       <button className="bi-search searchbtn ps-4" />
    //                       <input
    //                         placeholder="search"
    //                         className="form-control search_input_width rounded-pill border-0 bi-search"
    //                       />
    //                     </div>
    //                     <div className="dropdown d-flex justify-content-center justify-content-sm-start mt-2 mt-md-0">
    //                       <button
    //                         type="button"
    //                         className="btn bg-white rounded-pill d-flex sort_border px-4 mb-sm-0 mb-2"
    //                         data-bs-toggle="dropdown"
    //                       >
    //                         Sort{" "}
    //                         <i className="bi bi-filter-left my-auto ms-1 text-primary" />
    //                       </button>
    //                       <ul
    //                         className="dropdown-menu ps-3 text-primary fw-bold"
    //                         style={{ backgroundColor: "#EDEDED" }}
    //                       >
    //                         <li className="mb-3">Sort Data</li>
    //                         <li className="mb-3">End Data</li>
    //                         <li className="mb-3">Sort A-Z</li>
    //                         <li className="mb-3">Sort Z-A</li>
    //                       </ul>
    //                     </div>
    //                   </div>
    //                   <div className="swich_button mt-md-0 mt-sm-3 mt-2 my-2">
    //                     <ul
    //                       className="nav rounded-pill tabs_posetion"
    //                       id="myTab"
    //                     >
    //                       <li>
    //                         <button
    //                           className=" btn btn_active rounded-pill fw-bold px-4 active "
    //                           id="home-tab"
    //                           data-bs-toggle="tab"
    //                           data-bs-target="#home"
    //                           type="button"
    //                         >
    //                           ACTIVE
    //                         </button>
    //                       </li>
    //                       <li>
    //                         <button
    //                           className=" btn btn_active rounded-pill fw-bold px-4"
    //                           id="profile-tab"
    //                           data-bs-toggle="tab"
    //                           data-bs-target="#profile"
    //                           type="button"
    //                           role="tab"
    //                           aria-controls="profile"
    //                           aria-selected="false"
    //                         >
    //                           INACTIVE
    //                         </button>
    //                       </li>
    //                     </ul>
    //                   </div>
    //                 </div>
    //                 <div className="tab-content" id="myTabContent">
    //                   <div
    //                     className="tab-pane fade show active"
    //                     id="home"
    //                     role="tabpanel"
    //                     aria-labelledby="home-tab"
    //                   >
    //                     <div className=" h-100">
    //                       <div className="container-fluid">
    //                         <div className="row py-3">
    //                           {/* <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                       <Link to={'/vehicle-owner-new-campaigns'}>
    //                       <div>
    //                         <div className="card card_border_1">
    //                           <div className="div_background_color_1 py-2" style={{height: '180px'}}>
    //                             <h2 className=" pb-3">New <br />
    //                             Campaign<br />
    //                              Request!</h2>
    //                             <p>
    //                               Click to see more details
    //                             </p>
    //                           </div>
    //                           <div className='job_bg p-2'>
    //                           <p className=''>
    //                             Offer Expires:12/9/22
    //                           </p>
    //                           </div>
    //                         </div>

    //                       </div>
    //                       </Link>
    //                     </div> */}
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <Link to="detail">
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_nike.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "170px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="nike_chat_icon">
    //                                     <i className="bi bi-chat-left-fill fa-2x" />
    //                                   </div>
    //                                   <div className=" job_bg py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-1">
    //                                       Start Date:
    //                                       <span>01/08/2023</span>
    //                                     </p>
    //                                     <p className="mb-1">
    //                                       End Date:
    //                                       <span>05/20/2023</span>
    //                                     </p>
    //                                     <p className="">
    //                                       {" "}
    //                                       campaign :<span>Nike</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </Link>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <div>
    //                               <div className="card card_border div_posetion">
    //                                 <img
    //                                   className="card_img_top"
    //                                   src={require("../../assets/img/active_adidas.png")}
    //                                   alt="Card image"
    //                                   style={{ width: "100%", height: "170px" }}
    //                                 />
    //                                 <div className="photo_button"></div>
    //                                 <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                   <p className="mb-1">
    //                                     Start Date:
    //                                     <span>01/08/2023</span>
    //                                   </p>
    //                                   <p className="mb-1">
    //                                     End Date: <span>05/20/2023</span>
    //                                   </p>
    //                                   <p>
    //                                     campaign:
    //                                     <span>ADIDAS</span>
    //                                   </p>
    //                                 </div>
    //                               </div>
    //                             </div>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <div>
    //                               <div className="job_bg card card_border div_posetion">
    //                                 <img
    //                                   className="card_img_top"
    //                                   src={require("../../assets/img/active_waty.png")}
    //                                   alt="Card image"
    //                                   style={{ width: "100%", height: "170px" }}
    //                                 />
    //                                 <div className="photo_button"></div>
    //                                 <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                   <p className="">
    //                                     Start Date:
    //                                     <span>01/08/2023</span>
    //                                   </p>
    //                                   <p className="mb-0">
    //                                     End Date: <span>05/20/2023</span>
    //                                   </p>
    //                                 </div>
    //                               </div>
    //                             </div>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <div>
    //                               <div className="job_bg card card_border div_posetion">
    //                                 <img
    //                                   className="card_img_top"
    //                                   src={require("../../assets/img/active_hulu.png")}
    //                                   alt="Card image"
    //                                   style={{ width: "100%", height: "170px" }}
    //                                 />
    //                                 <div className="photo_button"></div>
    //                                 <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                   <p className="">
    //                                     Start Date:
    //                                     <span>01/08/2023</span>
    //                                   </p>
    //                                   <p className="mb-0">
    //                                     End Date: <span>05/20/2023</span>
    //                                   </p>
    //                                 </div>
    //                               </div>
    //                             </div>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <div>
    //                               <div className="card card_border div_posetion">
    //                                 <img
    //                                   className="card_img_top"
    //                                   src={require("../../assets/img/active_netflex.png")}
    //                                   alt="Card image"
    //                                   style={{ width: "100%", height: "170px" }}
    //                                 />
    //                                 <div className="photo_button"></div>
    //                                 <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                   <p className="">
    //                                     Start Date:
    //                                     <span>01/08/2023</span>
    //                                   </p>
    //                                   <p className="mb-0">
    //                                     End Date: <span>05/20/2023</span>
    //                                   </p>
    //                                 </div>
    //                               </div>
    //                             </div>
    //                           </div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                   <div
    //                     className="tab-pane fade"
    //                     id="profile"
    //                     role="tabpanel"
    //                     aria-labelledby="profile-tab"
    //                   >
    //                     <div className=" h-100">
    //                       <div className="container-fluid">
    //                         <div className="row py-3">
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <Link to={"/admin/campaign_detail"}>
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_nike.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "200px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="nike_chat_icon">
    //                                     <i className="bi bi-chat-left-fill fa-2x" />
    //                                   </div>
    //                                   <div className="card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-2">
    //                                       Start Date:
    //                                       <span>02/11/2023</span>
    //                                     </p>
    //                                     <p className="mb-2">
    //                                       End Date:
    //                                       <span>05/30/2023</span>
    //                                     </p>
    //                                     <p>
    //                                       Impressions:
    //                                       <span>1,123,9078</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </Link>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <a href="vehicleowners-view-Campaign.html">
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_adidas.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "200px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-2">
    //                                       Start Date:
    //                                       <span>02/11/2023</span>
    //                                     </p>
    //                                     <p className="mb-2">
    //                                       End Date:
    //                                       <span>05/30/2023</span>
    //                                     </p>
    //                                     <p>
    //                                       Impressions:
    //                                       <span>1,123,9078</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </a>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <a href="vehicleowners-view-Campaign.html">
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_waty.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "200px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-2">
    //                                       Start Date:
    //                                       <span>02/11/2023</span>
    //                                     </p>
    //                                     <p className="mb-2">
    //                                       End Date:
    //                                       <span>05/30/2023</span>
    //                                     </p>
    //                                     <p>
    //                                       Impressions:
    //                                       <span>1,123,9078</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </a>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <a href="./jobs_just_do_it.html">
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_hulu.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "200px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-2">
    //                                       Start Date:
    //                                       <span>02/11/2023</span>
    //                                     </p>
    //                                     <p className="mb-2">
    //                                       End Date:
    //                                       <span>05/30/2023</span>
    //                                     </p>
    //                                     <p>
    //                                       Impressions:
    //                                       <span>1,123,9078</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </a>
    //                           </div>
    //                           <div className="col-lg-4 col-md-6 px-4 mb-5">
    //                             <a href="./jobs_just_do_it.html">
    //                               <div>
    //                                 <div className="card card_border div_posetion">
    //                                   <img
    //                                     className="card_img_top"
    //                                     src={require("../../assets/img/active_netflex.png")}
    //                                     alt="Card image"
    //                                     style={{
    //                                       width: "100%",
    //                                       height: "200px",
    //                                     }}
    //                                   />
    //                                   <div className="photo_button"></div>
    //                                   <div className="card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
    //                                     <p className="mb-2">
    //                                       Start Date:
    //                                       <span>02/11/2023</span>
    //                                     </p>
    //                                     <p className="mb-2">
    //                                       End Date:
    //                                       <span>05/30/2023</span>
    //                                     </p>
    //                                     <p>
    //                                       Impressions:
    //                                       <span>1,123,9078</span>
    //                                     </p>
    //                                   </div>
    //                                 </div>
    //                               </div>
    //                             </a>
    //                           </div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //           <div className="d-flex justify-content-end me-5">
    //             <Pagination count={10} shape="rounded" />
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};
